export const productTypeMap = {
  "-1": "biosimilar-groups",
  1: "presentations",
  2: "generic-groups",
  3: "accessories-groups",
  4: "veterinary",
  5: "dietetic",
  6: "dermato",
  7: "accessory",
  8: "horsAmm",
  9: "segmentations",
  10: "indications",
  11: "side-effect",
  12: "ranges",
  13: "brands",
  14: "companies",
  15: "molecules",
  16: "common-names",
  17: "specialities",
  20: "biosimilar-groups",
  21: "atc-classes",
  22: "bcb-classes",
  23: "universes",
  24: "generic-groups",
  27: "lpp",
};

export const productTypeToDisplayMap = {
  1: "Médicament",
  2: "Groupe générique",
  3: "Groupe accessoires",
  4: "Vétérinaire",
  5: "Diététique",
  6: "Dermatologie",
  7: "Accessoire",
  8: "Hors AMM",
  9: "Segment",
  10: "Indication",
  11: "Effet indésirable",
  12: "Gamme",
  13: "Marque",
  14: "Laboratoire",
  15: "Composant",
  16: "DC",
  17: "Spécialité",
  18: "UCD",
  19: "Pathologie",
  20: "Groupe biosimilaire",
  21: "Classe ATC",
  22: "Classe Claude Bernard",
  23: "Univers Pharmaceutique",
  24: "Référentiels et listes de médicaments",
  27: "LPP",
};
